import { render, staticRenderFns } from "./AccountingApproval.vue?vue&type=template&id=328d8e4c&scoped=true"
import script from "./AccountingApproval.vue?vue&type=script&lang=js"
export * from "./AccountingApproval.vue?vue&type=script&lang=js"
import style0 from "./AccountingApproval.vue?vue&type=style&index=0&id=328d8e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d8e4c",
  null
  
)

export default component.exports